import { render } from "./TextBody.vue?vue&type=template&id=9ef4849c&scoped=true"
import script from "./TextBody.vue?vue&type=script&lang=js"
export * from "./TextBody.vue?vue&type=script&lang=js"

import "./TextBody.vue?vue&type=style&index=0&id=9ef4849c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef4849c"]])

export default __exports__